import * as React from 'react';
import Typography from "@mui/material/Typography/Typography";
import Stack from "@mui/material/Stack/Stack";
import Box from "@mui/material/Box/Box";
import IconButton from "@mui/material/IconButton/IconButton";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import moment from "moment/moment";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";
export default function TextMessageComponent({msg, type}){
  if (type === 'r') {
    return (

      <Stack direction={'row-reverse'} spacing={1}>
        <Stack direction={'row'} spacing={1} sx={{ p:1, backgroundColor: '#204488',  color: '#fff', borderRadius: '5px', maxWidth:'70%'}} justifyContent="flex-end"
               alignItems="flex-end">
          <Typography variant={'body2'} sx={{mb: 1}}>
            {msg?.text}
          </Typography>
          <Stack direction={'row'} spacing={.5}>

            <Typography variant={'caption'}>
              {msg.createdAt && moment(msg.createdAt.seconds * 1000).format('HH:mm')}
            </Typography>

            {msg.read === true ?    <DoneAllOutlinedIcon style={{color: '#4acfee',fontSize: 18}}  /> :<DoneAllOutlinedIcon  style={{color:'#ccc',fontSize: 18}}/>

            }

          </Stack>
        </Stack>
      </Stack>
    )
  } else {
    return (
      <Stack direction={'row'} spacing={1}>
        <Stack direction={'row'} spacing={1} sx={{ p:1, backgroundColor:'#F1F1F1', borderRadius: '5px', maxWidth:'70%'}} justifyContent="flex-end"
               alignItems="flex-end">
          <Typography variant={'body2'} sx={{width: '100%', textAlign:'left', mb: 1}}>
            {msg?.text}
          </Typography>
          <Stack direction={'row'} spacing={.5}>

            <Typography variant={'caption'} color={'secondary'}>
              {msg.createdAt && moment(msg.createdAt.seconds * 1000).format('HH:mm')}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    )
  }
}